/**
 * Allowed values for the `layers.type` column.
 *
 * Source of truth is the DB CHECK constraint `layers_type_check`, defined in
 * `src/backend/migrations/005_add_var_layer_type.sql`. The drift test in
 * `src/test/components/layerAdminExplorer/layerTypes.drift.test.ts` reads
 * the latest migration and asserts this list matches — so any future type
 * addition forces a single coordinated update here.
 */
export const LAYER_TYPES = [
  'wms',
  'wfs',
  'tms',
  'live',
  'geojson',
  'mapbox-style',
  'var',
] as const;

export type LayerType = (typeof LAYER_TYPES)[number];
